<template>
    <div class="card" style="min-height: 400px">
      <div class="col-12 mt-2 mb-4">
        <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th class="text-center">Payroll Category</th>
          <th class="text-center">Calculation Period</th>
          <th class="text-center">Start Date</th>
          <th class="text-center">End Date</th>
          <th class="text-center">Total Earning</th>
          <th class="text-center">Total Deduction</th>
          <th class="text-center">Total Net Payable</th>
          <th class="text-center">Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in payrollProcessDraftList" :key="i">
          <td class="text-center text-capitalize">{{ item.payroll_category_name }}</td>
          <td class="text-center">{{ item.payroll_period_name }}</td>
          <td class="text-center">{{ item.payroll_start_date }}</td>
          <td class="text-center">{{ item.payroll_end_date }}</td>
          <td class="text-center">{{ item.total_earning }}</td>
          <td class="text-center">{{ item.total_deduction }}</td>
          <td class="text-center">{{ item.total_net_payable }}</td>
          <td class="text-center text-capitalize">{{ item.payroll_approval_status_name }}</td>
          <td v-if="['draft'].includes(item.approval_status)" class="text-center">
            <button class="btn btn-primary btn-sm mb-1"
                    title="Reprocess"
                    v-if="item.payroll_category != 'final_settlement'"
                    @click="reprocess(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-sync"></i>
            </button>
            <button class="btn btn-primary btn-sm mx-1 mb-1"
                    @click="goToShow(item, 'payroll-view')"
                    style="cursor: pointer"
                    title="View"
            >
              <i class="fas fa-eye"></i>
            </button>
            <button class="btn btn-primary btn-sm mb-1"
                    @click="goToShow(item, 'payroll-adjustment')"
                    style="cursor: pointer"
                    title="Payroll Adjustment"
            >
              <i class="fas fa-plus-circle"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="payrollProcessDraftList.length < 0" class="text-center mt-5">No data</p>
    </div>
      </div>
    </div>

    <div class="px-2 position-absolute bottom-0 mt-4">
      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>
</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const store = useStore();
const route = useRoute();
const router = useRouter();
const loading = ref(false)
const params = ref({
  offset: 20,
});
const payrollProcessDraftList = ref([])
const emit = defineEmits(['reprocess']);

const {
  fetchPayrollProcessData
} = handleHrPayroll()

const reprocess = (item) => {
  emit('reprocess', item);
  getPayrollProcessDraftList()
};

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPayrollProcessDraftList();
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const goToShow = (item, routeName = 'payroll-view') => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
    payrollMasterId:item.id
  }

  let query = route.query;

  router.push({
    name:  routeName,
    params: param,
    query: query
  })
}

const getPayrollProcessDraftList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&approval_status=draft'

  loading.value = true
  payrollProcessDraftList.value = []

  await fetchPayrollProcessData(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    payrollProcessDraftList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  Promise.all([
    getPayrollProcessDraftList()
  ])
})

</script>
